module.exports = __webpack_public_path__ + "img/spinner.1a22af59.gif";